import { render, staticRenderFns } from "./BulkBookSalesDialog.vue?vue&type=template&id=c4d170e0&"
import script from "./BulkBookSalesDialog.vue?vue&type=script&lang=ts&"
export * from "./BulkBookSalesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports